<template>
	<div class="uk-container">
		<div class="uk-position-center">
			<div uk-spinner="ratio: 3"></div>
			<h5 class="uk-text-center">Cargando...</h5>
		</div>
	</div>
</template>
